(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deoxy-product-reviews"] && !Shopify.designMode) return;
  try {
    

(function () {

  var ENDPOINT =
    'https://deoxy-review-submit.andy-ffc.workers.dev';


  function initialiseReviewForm() {

    var form = document.getElementById('DeoxyReviewForm');

    if (!form || form.dataset.deoxyInitialised === 'true') {
      return;
    }

    form.dataset.deoxyInitialised = 'true';

    var submitButton =
      document.getElementById('DeoxyReviewSubmit');

    var message =
      document.getElementById('DeoxyReviewMessage');


    form.addEventListener('submit', async function (event) {

      event.preventDefault();

      message.hidden = true;
      message.classList.remove('is-error');


      if (!form.checkValidity()) {

        form.reportValidity();
        return;

      }


      var formData = new FormData(form);

      var payload = {
        product_id: formData.get('product_id'),
        product_title: formData.get('product_title'),
        product_url: formData.get('product_url'),
        variant_id: formData.get('variant_id'),
        variant_title: formData.get('variant_title'),
        name: formData.get('name'),
        email: formData.get('email'),
        rating: Number(formData.get('rating')),
        title: formData.get('title'),
        body: formData.get('body'),
        website: formData.get('website')
      };


      submitButton.disabled = true;
      submitButton.textContent = 'SUBMITTING…';


      try {

        var response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });


        var result = await response.json();


        if (!response.ok || !result.ok) {

          throw new Error(
            result.error ||
            'We couldn’t submit your review. Please try again.'
          );

        }


        message.textContent =
          'Thank you. Your review has been submitted and will appear once approved.';

        message.hidden = false;

        form.reset();

        message.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });


      } catch (error) {

        message.textContent =
          error.message ||
          'We couldn’t submit your review. Please try again.';

        message.classList.add('is-error');
        message.hidden = false;

      } finally {

        submitButton.disabled = false;
        submitButton.textContent = 'SUBMIT REVIEW';

      }

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseReviewForm
    );

  } else {

    initialiseReviewForm();

  }


  document.addEventListener(
    'shopify:section:load',
    initialiseReviewForm
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
